import './theme';
import './style.less';
import vue from 'vue';
import vueTape from 'vue-tape';
import { VueJsonp } from "vue-jsonp";
import state, { readState, commitState, onWatchState, offWatchState } from './base/state';
import router, { setEnableRouter, openPageByUrl, openPostPage, openRoutePage, openRouteDrawer, replaceRouteDrawer } from './base/router';
import { genUrl } from './utils/query';
import { uuidv4 } from './utils/uuid';
import { inPc, bridgeCall } from './base/bridge';
import { getConfig, setCustomConfig, getQrCodeUrl } from './base/config';
import { onChanged, offChanged } from './utils/changed';
import { requestApi } from './base/request';
import { toAny } from './utils/toany';
import { hex_md5 } from './utils/md5';
import { getCart, addCart, removeCart, clearCart } from './cart';
import { onScan, offScan, onScaning, offScaning } from './scan';
import { getDarkColor, getLightColor } from './utils/color';
import { printInventory, printOrder } from './print';
import VueAffixBox from 'vue-affix-box'
import watermark from './watermark';
import './base/proto';
import './libs';


// vue-tape
vue.use(vueTape);
vue.use(VueJsonp);
vue.use(VueAffixBox)


export function init(app, error, flag) {
    // enable router
    setEnableRouter(flag);
    // init app
    vueTape.initApp({
        app,
        error,
        el: '#app',
        options: {
            router,
        },
        stateOptions: {
            defaultValues: state,
            keyPrefix: "web_v2_"
        },
    }, (vue) => {
        vue.prototype.setWatermark = watermark.set;
        vue.prototype.inPc = inPc;
        vue.prototype.getQrCodeUrl = getQrCodeUrl;
        vue.prototype.onWatchState = onWatchState;
        vue.prototype.offWatchState = offWatchState;
        vue.prototype.bridgeCall = bridgeCall;
        vue.prototype.getDarkColor = getDarkColor;
        vue.prototype.getLightColor = getLightColor;
        vue.prototype.genUrl = genUrl;
        vue.prototype.uuidv4 = uuidv4;
        vue.prototype.toAny = toAny;
        vue.prototype.getCart = getCart;
        vue.prototype.addCart = addCart;
        vue.prototype.removeCart = removeCart;
        vue.prototype.clearCart = clearCart;
        vue.prototype.hexMd5 = hex_md5;
        vue.prototype.onScan = onScan;
        vue.prototype.offScan = offScan;
        vue.prototype.onScaning = onScaning;
        vue.prototype.offScaning = offScaning;
        vue.prototype.onChanged = onChanged;
        vue.prototype.offChanged = offChanged;
        vue.prototype.readState = readState;
        vue.prototype.commitState = commitState;
        vue.prototype.printInventory = printInventory;
        vue.prototype.printOrder = printOrder;
        vue.prototype.openPageByUrl = openPageByUrl;
        vue.prototype.openPostPage = openPostPage;
        vue.prototype.openRouteDrawer = openRouteDrawer;
        vue.prototype.replaceRouteDrawer = replaceRouteDrawer;
        vue.prototype.openRoutePage = openRoutePage;
        vue.prototype.requestApi = requestApi;
        vue.prototype.getConfig = getConfig;
        return requestApi("api.system.global.setting.detail", {
            settingKey: 'system_global_website_config'
        }).then((resp) => {
            return resp.data && resp.data.settingValue || {};
        }).catch(() => {
            return readState("globalWebSiteConfig");
        }).then((conf) => {
            if (!conf) {
                throw new Error("加载商户版配置失败！");
            }
            commitState({ globalWebSiteConfig: conf });
            setCustomConfig(conf);
        });
    });
}
